uniform float uTime;
uniform float uAspect;
uniform vec2 uLightPosition;
uniform float uRayCount;
uniform float uRaySpeed;

// control these with dat.gui:
uniform float uLargeVariation; // default 1.0 (range (0, 2))
uniform vec3 lightColor; // default  vec3(1.0, 0.9, 0.7);
uniform float uGammaBorder; // default 1.0 (range (0, 4))
uniform float uLightIntensity;
uniform vec2 uUVScale; // control UV scaling

// end control

varying vec2 vUv;

// Hash function for pseudo-random numbers
float hash21(vec2 p) {
    p = fract(p * vec2(234.34, 435.345));
    p += dot(p, p + 34.23);
    return fract(p.x * p.y);
}

// 2D Noise
float noise(vec2 p) {
    vec2 i = floor(p);
    vec2 f = fract(p);
    
    float a = hash21(i);
    float b = hash21(i + vec2(1.0, 0.0));
    float c = hash21(i + vec2(0.0, 1.0));
    float d = hash21(i + vec2(1.0, 1.0));
    
    vec2 u = f * f * (3.0 - 2.0 * f);
    return mix(a, b, u.x) + (c - a) * u.y * (1.0 - u.x) + (d - b) * u.x * u.y;
}

// FBM (Fractional Brownian Motion)
float fbm(vec2 p, float frequency) {
    float value = 0.0;
    float amplitude = 1.0;
    // float frequency = 0.7;
    float total = amplitude;
    for(int i = 0; i < 4; i ++ ) {
        value += amplitude * noise(p * frequency);
        frequency *= 2.0;
        amplitude *= 0.5;
        total += amplitude;
    }
    return value / total;
}

// Function to create a radial ray pattern
float rays(vec2 uv, vec2 lightPos, float count, float time, float freq) {
    vec2 toLight = uv - lightPos;
    float angle = atan(toLight.y, toLight.x);
    float dist = length(toLight);
    
    // Create periodic noise coordinates
    float noiseScale = 5.0;
    vec2 noiseCoord = vec2(
        cos(angle) * noiseScale + time * 0.2,
        sin(angle) * noiseScale + time * 0.1
    );
    float variation = pow(fbm(noiseCoord, freq), 2.0) * 2.0;
    
    // Combine noise with base ray pattern
    float rayLength = 0.75 + variation * 0.25;
    float rays = abs(sin(angle * count + -time * uRaySpeed + variation * 5.0));
    
    float falloff = max(0.0, 1.0 - dist / 0.5); // - dist / 0.25 ;//pow(1.0 - smoothstep(0.0, 0.5 - (1.0 - rayLength) * 0.5, dist), 1.0)*1.0;
    return variation * falloff; // * (0.8 + rays * 0.2);
}

void main() {
    vec2 uv = vUv;
    // Scale UV based on width and height controls
    uv = (uv - 0.5) * uUVScale + 0.5;
    
    // Create animated rays
    float ray = rays(uv, uLightPosition, uRayCount, uTime * 1.0, 0.5);
    float ray2 = rays(uv, uLightPosition, uRayCount, uTime * 2.0, 0.4);
    
    ray *= (1.0 - uLargeVariation) + ray2 * 3.0 * uLargeVariation;
    // Create a soft glow around the light source
    float glow = 0.0; //1.0 - smoothstep(0.0, 0.5, length(vUv - uLightPosition));
    
    // Combine rays and glow
    float shine = ray * uLightIntensity + glow * 0.5;
    
    // Create warm light color — baseColor is a darkened tint of lightColor
    float dist = 0.5 + pow(length(vUv - vec2(0.5, 0.5)), 2.0);
    vec3 baseColor = lightColor * 0.1;
    vec3 finalColor = pow(baseColor, vec3(dist)) * 0.1 * uLightIntensity + vec3(0.0, 0.0, 0.0) + pow(lightColor, vec3(1.0 / max(0.00001, shine) * uGammaBorder)) * shine;
    // vec3 finalColor = vec3(0.0, 0.0, 0.0) + lightColor* shine;
    
    gl_FragColor = vec4(finalColor, 1.0);
}
